module.exports = __webpack_public_path__ + "img/clouds.becc56a1.png";